export const BANNER_LINK_TYPES = ["deep-link", "web-link"] as const;

export type BannerLinkType = (typeof BANNER_LINK_TYPES)[number];

export interface Banner {
  id: string;
  imageUrl: string;
  link: string;
  linkType: BannerLinkType;
  position: number;
}

export interface CreateBanner {
  imageUrl: string;
  link: string;
  linkType: BannerLinkType;
}

export type UpdateBanner = Partial<CreateBanner>;

export interface ReorderBanners {
  ids: string[];
}

export interface UploadedBannerImage {
  url: string;
}
